<template :key="alias">
  <div class="product">
    <Header />

    <div class="breadcrumb-area gray-bg">
      <div class="container">
        <div class="breadcrumb-content">
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li class="active">{{ event.name }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container my-4" v-if="loader">
      <i class="fa fa-spinner fa-spin product-loader centered"></i>
    </div>

    <template v-if="error">
      <div class="container my-4">
        <div class="alert alert-danger mb-4" role="alert">
          <i class="fa fa-times mr-2"></i>
          Event could not be found!
        </div>
      </div>
    </template>
    <template v-else>
      <div class="product-details product-view mt-25 mb-25" v-if="!loader">
        <div class="container bg-white p-4">
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="product-details-img">
								<b-carousel
									id="carousel-1"
									v-model="slide"
									controls
									indicators
									img-width="1024"
									img-height="480"
									@sliding-start="onSlideStart"
									@sliding-end="onSlideEnd"
								>
									<b-carousel-slide>
										<template #img>
											<img class="d-block img-fluid zoompro" width="70%" height="auto" :src="serverUrl + '/storage/events/' + event.main_photo" alt="Event Image">
										</template>
									</b-carousel-slide>

									<b-carousel-slide v-if="event.photo_two != null">
										<template #img>
											<img class="d-block img-fluid zoompro" width="70%" height="auto" :src="serverUrl + '/storage/events/' + event.photo_two" alt="Product Image">
										</template>
									</b-carousel-slide>

									<b-carousel-slide v-if="event.photo_three != null">
										<template #img>
											<img class="d-block img-fluid zoompro" width="70%" height="auto" :src="serverUrl + '/storage/events/' + event.photo_three" alt="Product Image">
										</template>
									</b-carousel-slide>

									<b-carousel-slide v-if="event.photo_four != null">
										<template #img>
											<img class="d-block img-fluid zoompro" width="70%" height="auto" :src="serverUrl + '/storage/events/' + event.photo_four" alt="Product Image">
										</template>
									</b-carousel-slide>

								</b-carousel>

                <div id="gallery" class="mt-20 product-dec-slider owl-carousel" align="center">
									<a v-if="event.main_photo != null" @click="showImage(0)">
                    <img :src="serverUrl + '/storage/events/' + event.main_photo" width="90px"/>
                  </a>

                  <a v-if="event.photo_two != null" @click="showImage(1)">
                    <img
                      :src="serverUrl + '/storage/events/' + event.photo_two"
                      width="90px"
                    />
                  </a>

                  <a v-if="event.photo_three != null" @click="showImage(2)">
                    <img
                      :src="serverUrl + '/storage/events/' + event.photo_three"
                      width="90px"
                    />
                  </a>

                  <a v-if="event.photo_four != null" @click="showImage(3)">
                    <img
                      :src="serverUrl + '/storage/events/' + event.photo_four"
                      width="90px"
                    />
                  </a>
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-12">
              <div class="product-details-content">

                <h4>{{ event.name }}</h4>
                <hr class="my-2" />	

                <div class="in-stock mt-2">
									<p><b class="mustard-text">From:</b> {{ dateFormat(event.start_date) }}, {{event.start_time}}</p>
                </div>

								<div class="in-stock mt-2">
									<p><b class="mustard-text">To:</b> {{ dateFormat(event.end_date) }}, {{event.end_time}}</p>
                </div>

								<div class="in-stock mt-2">
									<p><b class="mustard-text">Venue:</b> {{event.venue}}</p>
                </div>

								<div class="in-stock mt-2">
									<p><b class="mustard-text">Host:</b> {{event.vendor.name}}</p>
                </div>

								<div class="in-stock mt-2">
									<b class="mustard-text">Description:</b>
									<div class="py-2">
										<span v-html="event.description"></span>
									</div>
								</div>

                <div class="pro-dec-social mt-2">
                  <label class="pb-2">Share this event</label>
                  <ul>
                    <li>
                      <span
                        class="social p-2 twitter-social"
                        @click="twitterShare()"
                        ><i class="ion-social-twitter px-2"></i
                      ></span>
                    </li>
                    <li>
                      <span
                        class="social p-2 rounded fb-social"
                        @click="facebookShare()"
                        ><i class="ion-social-facebook px-2"></i
                      ></span>
                    </li>
                    <li>
                      <span
                        class="social p-2 rounded wa-social"
                        @click="waShare()"
                        ><i class="ion-social-whatsapp-outline px-2"></i
                      ></span>
                    </li>
                  </ul>
                </div>

								<div class="in-stock mt-4">
									<a href="#buy-ticket" class="btn btn-goldenchef-secondary btn-block py-1 rounded text-white">
										<i class="ion-android-cart" aria-hidden="true"></i>
										Buy Ticket
									</a>	
								</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="description-review-area product-view mb-25" v-if="!loader">
        <div class="container bg-white py-4 mobile-container" id="buy-ticket">
          <div class="description-review-wrapper">
            <div class="description-review-topbar nav text-center">
              <a>Tickets</a>
            </div>

            <div class="tab-content description-review-bottom">
              <div class="tab-pane active">
                <div class="product-description-wrapper">
                  <div class="table-content table-responsive bg-white">
									<table class="table-bordered desktop-table" width="100%">
										<thead>
											<tr style="height:50px">
												<th>Type</th>
												<th>Price</th>
												<th>Quantity</th>
												<th>Sub-total</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="ticket in ticketTypes" v-bind:key="ticket.id">

												<td>{{ticket.name}}</td>

												<td>KSh. {{numberFormat(ticket.price)}}</td>

												<td>
													<div class="px-4">
														<template v-if="ticket.quantity_remaining > 10">
															<select class="form-control rounded" ref="quantity" @change="changeTicketPrice($event, ticket)">
																<option selected value="0"> 0 </option>
																<option v-for="item in 10" :key="item">
																	{{ item }}
																</option>
															</select>
														</template>

														<template v-if="ticket.quantity_remaining <= 10 && ticket.quantity_remaining > 0">
															<select class="form-control rounded" ref="quantity" @change="changeTicketPrice($event, ticket)">
																<option selected value="0" > 0 </option>
																<option v-for="item in parseInt(ticket.quantity_remaining)" :key="item">
																	{{ item }}
																</option>
															</select>
														</template>

														<template v-if="ticket.quantity_remaining <= 0">
																<span class="badge badge-dark">Sold Out</span>
														</template>
													</div>												
												</td>

												<td>
													KSH. {{numberFormat(ticket.subtotal)}}
												</td>  
											</tr>
										</tbody>
									</table>

										<table class="table-bordered mobile-table" width="100%" style="display: none">												
												<template v-for="(ticket, index) in ticketTypes">
													<tr :key="'ticket_name' + index">
														<th class="mobile-table-dark text-white" colspan="2">{{ticket.name}}</th>
													</tr>

													<tr :key="'ticket_price' + index">
														<th>Price</th>
														<td>KSh. {{numberFormat(ticket.price)}}</td>
													</tr>

													<tr :key="'ticket_quantity' + index">
														<th>Quantity</th>
														<div class="p-4">
															<template v-if="ticket.quantity_remaining > 10">
																<select class="form-control rounded" ref="quantity" @change="changeTicketPrice($event, ticket)">
																	<option selected value="0"> 0 </option>
																	<option v-for="item in 10" :key="item">
																		{{ item }}
																	</option>
																</select>
															</template>

															<template v-if="ticket.quantity_remaining <= 10 && ticket.quantity_remaining > 0">
																<select class="form-control rounded" ref="quantity" @change="changeTicketPrice($event, ticket)">
																	<option selected value="0" > 0 </option>
																	<option v-for="item in parseInt(ticket.quantity_remaining)" :key="item">
																		{{ item }}
																	</option>
																</select>
															</template>

															<template v-if="ticket.quantity_remaining <= 0">
																	<span class="badge badge-dark">Sold Out</span>
															</template>
														</div>
													</tr>

													<tr :key="'ticket_subtotal' + index">
														<th>Sub-total</th>
														<td>
															KSH. {{numberFormat(ticket.subtotal)}}
														</td>  
													</tr>														
												</template>
										</table>
								</div>
                </div>
								<div class="row">
									<div class="col-lg-4 col-md-6"> 
									</div>
									<div class="col-lg-4 col-md-6"> 
									</div>
									
									<div class="col-lg-4 col-md-12">
											<div class="grand-totall">
													<h4 class="grand-totall-title m-0">Sub Total  <span>KSh {{numberFormat(subtotal)}}</span></h4>
													
													<button class="btn btn-goldenchef-secondary btn-block mt-4 py-2 rounded text-white" @click="checkout()">
														<span class="btn_text text-white" v-show="!checkoutLoader">Checkout</span>
														<i class="fa fa-spinner fa-spin mt-2 text-white" v-show="checkoutLoader"></i>
													</button>
											</div>
									</div>
							</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <Footer />
  </div>
</template>

<script>
import { mapState, mapGetter, mapActions } from "vuex";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Events from "../apis/events";
import Tickets from "../apis/tickets";


export default {
  name: "Event",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      event: {},

      checkoutLoader: false,
      error: false,
      successAlert: false,
      errorAlert: false,
      message: null,

      loader: true,
			slide: 0,
			sliding: null,

			ticketTypes: [],
			tickets: [],

			subtotal: 0,
			grandtotal: 0,
			quantitySold: 0,
    };
  },
  computed: {
    ...mapState(["serverUrl"]),
    ...mapState("auth", ["userData"]),
  },
  created: function () {
    this.getEvent();
  },

	mounted: function () {
    //
  },

  methods: {
		...mapActions(["addEvent"]),

    getEvent() {
      var that = this;
      var alias = this.$route.params.id;

      if (alias != null) {
        Events.show(alias)
          .then((response) => {
            that.loader = false;

            if (response.data.alias != null) {
              that.event = response.data;
							
							that.event.ticket_types.forEach(function (ticket) {
								ticket.subtotal = 0
								that.ticketTypes.push(ticket)
							});
            } else {
              that.error = true;
            }
          })
          .catch(function (error) {
            alert(error);
          });
      }
    },
		
		changeTicketPrice(e, ticket) {			
			ticket.quantity = e.target.value;
			ticket.subtotal = ticket.price * ticket.quantity;

			var index = this.ticketTypes.indexOf(ticket)
			this.ticketTypes.splice(index, 1, ticket)

			this.updateTotal()
		},

		updateTotal() {
			var that = this		
			that.subtotal = 0
			that.quantitySold = 0

			that.ticketTypes.forEach(function (ticket) {
				if(ticket.subtotal > 0) {
					that.subtotal += ticket.subtotal
					that.quantitySold += parseInt(ticket.quantity)
				}				
			});
		},

		checkout() {
			var data = {}
			var tickets= []
			var commissionAmount
			var commissionPercentage
			this.checkoutLoader = true

			this.ticketTypes.forEach(function (ticket) {
				if(ticket.subtotal > 0)
					tickets.push(ticket)
			});
			
			if(this.event.billing_mode == "bill_customer") {
				commissionAmount = Math.ceil(this.event.billing_amount/100 * this.subtotal) 
				this.grandtotal = this.subtotal + commissionAmount
			}

			else if(this.event.billing_mode == "split_bill") {
				commissionPercentage = this.event.billing_amount/2
				commissionAmount = Math.ceil(commissionPercentage/100 * this.subtotal) 
				this.grandtotal = this.subtotal + commissionAmount
			}
			else {
				this.grandtotal = this.subtotal
			}

			data.event_id = this.event.id
			data.billing_mode = this.event.billing_mode
			data.billing_amount = this.event.billing_amount
			data.commission_amount = commissionAmount
			data.subtotal = this.subtotal
			data.total_revenue = this.grandtotal
			data.quantity_sold = this.quantitySold
			data.tickets = tickets

			console.log(data)

			if(data.total_revenue > 0) {
				this.addEvent(data)
				this.$router.push('/checkout');
			}
			else {
				this.checkoutLoader = false
				alert("Grand total cannot be 0")
			}
			
		},

		onSlideStart(slide) {
        this.sliding = true
		},

		onSlideEnd(slide) {
			this.sliding = false
		},

		showImage(index) {
			this.slide = index
		},

		dateFormat(date) {
			var dateObj = new Date(date);

			let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
			var longDate = dateObj.toLocaleString('en-US', options);  

			return longDate
		},

		numberFormat(number) {
    	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

    twitterShare() {
      var url = encodeURIComponent(
        "https://ticketmojo.co.ke/event/" + this.event.alias
      );
      window.open(
        "https://twitter.com/share?url=" +
          url +
          "&text=Checkout this product on Ticket Mojo",
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
      );
      return false;
    },

    facebookShare() {
      var url = encodeURIComponent(
        "https://ticketmojo.co.ke/event//event/" + this.event.alias
      );

      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + url,
        "",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
      );
      return false;
    },

    waShare() {
      var url = encodeURIComponent(
        "https://ticketmojo.co.ke/event//event/" + this.event.alias
      );
      window.open(
        "https://api.whatsapp.com/send?text=Hi%2C+checkout+this+event%3A%0D%0A%0D%0A*" +
          this.event.name +
          "%0D%0A*URL:*%20" +
          url +
          "%2F%0D%0A%0D%0AThank+you%21"
      );
      return false;
    },
  },
};
</script>
